import { render, staticRenderFns } from "./YcAutocomplete.vue?vue&type=template&id=2327a509&scoped=true&lang=pug&"
import script from "./YcAutocomplete.vue?vue&type=script&lang=js&"
export * from "./YcAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./YcAutocomplete.vue?vue&type=style&index=0&id=2327a509&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327a509",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VChip,VIcon})
